import {TUTORIAL} from "utils/constants";

export const initTutorial = info => ({
  type: TUTORIAL.INIT_TUTORIAL,
  payload: info,
});

export const handleTutorialPanel = () => ({
  type: TUTORIAL.HANDLE_TUTORIAL_PANEL,
});

export const handleTutorialList = () => ({
  type: TUTORIAL.HANDLE_TUTORIAL_LIST,
});

export const handleTutorialMission = index => ({
  type: TUTORIAL.HANDLE_TUTORIAL_MISSION,
  payload: index,
});

export const handleTutorialCompletedMissionIdx = index => ({
  type: TUTORIAL.HANDLE_TUTORIAL_COMPLETED_MISSION_IDX,
  payload: index,
});

export const getMyProjectData = data => ({
  type: TUTORIAL.GET_MY_PROJECT_INFO,
  payload: data,
});
